import React from 'react';
import Hello from '../components/Hello';

const HomePage = () => {
  return (
    <div className="page-container">
      <Hello />
    </div>
  );
};

export default HomePage;